// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1N-zC","header":"MessagesList_header__2zsqe","chat":"MessagesList_chat__1mjXL"};